export default "__VITE_ASSET__TZBU6kjH__"